import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class HeadersValidatorInterceptor implements HttpInterceptor {
  public intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const approvedRegExp = /^[\w\s_:;.,\\/"'?!(){}[\]@<>=+\-*#$&`|~^%]+$/;

    const headers = request.headers
      .keys()
      .reduce(
        (headers, key) =>
          approvedRegExp.test(request.headers.get(key))
            ? headers.set(key, request.headers.get(key))
            : headers,
        new HttpHeaders());

    return next.handle(request.clone({ headers }));
  }
}
